import BusyLoading from "Components/Loading/BusyLoading/BusyLoading";
import * as React from "react";

interface IProps {}

export class LoginComponent extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (<BusyLoading />);
    }
}

export default LoginComponent;


// WEBPACK FOOTER //
// ./src/Components/Authentication/LoginComponent.tsx